import * as React from 'react';

import { Context } from './component';

export const useConfirmDialog = () => {
  return React.useContext(Context);
};
